import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import {
  listAffiliateCommissionsPaged,
  getMyAffiliateBundle,
} from '@/modules/affiliates/services/affiliateInsightsService'
import CommissionsTable from '@/modules/affiliates/components/CommissionsTable'
import { Pagination } from '@/shared/ui/Pagination'

export default function MyComissoesPage() {
  const { profile } = useAuth()
  const uid = profile?.id || ''
  const [rows, setRows] = React.useState<any[]>([])
  const [nameMap, setNameMap] = React.useState<Record<string, string>>({})
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [page, setPage] = React.useState(1)
  const [total, setTotal] = React.useState(0)
  const pageSize = 25

  React.useEffect(() => {
    ;(async () => {
      if (!uid) return
      setLoading(true)
      setError(null)
      try {
        const { rows, total } = await listAffiliateCommissionsPaged(uid, page, pageSize)
        setRows(rows)
        setTotal(total)

        try {
          const bundle = await getMyAffiliateBundle()
          const map: Record<string, string> = {}
          for (const referred of bundle.referred || []) {
            if (referred.account_id) {
              map[referred.account_id] = String(referred.account_name || '')
            }
          }
          setNameMap(map)
        } catch {
          // erro ao carregar nomes n\u00e3o impede visualiza\u00e7\u00e3o das comiss\u00f5es
        }
      } catch (e: any) {
        setError(e?.message || 'Falha ao carregar comiss\u00f5es')
      } finally {
        setLoading(false)
      }
    })()
  }, [uid, page, pageSize])

  return (
    <div className="w-full">
      <h1 className="mb-4 text-2xl font-semibold">{'Comiss\u00f5es'}</h1>
      {error && (
        <div className="mb-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
          {error}
        </div>
      )}
      {loading ? (
        <div className="text-sm text-foreground/70">Carregando...</div>
      ) : (
        <>
          <CommissionsTable rows={rows as any} accountNames={nameMap} />
          <div className="mt-4 flex justify-end">
            <Pagination
              page={page}
              total={Math.max(1, Math.ceil(total / pageSize))}
              onChange={setPage}
            />
          </div>
        </>
      )}
    </div>
  )
}

